<template>
    <div class="animated fadeIn">
        <h3>Sekvenser</h3>
        <div class="card">
            <div class="card-body">
                <b-row>
                    <b-col cols="2">
                        <b-row v-for="st in seqTypes" :key="st.SequenceTypeId">
                            <b-button block :variant="currSeqType==st ? 'primary':'outline-secondary'" @click="SelectSeqType(st)">
                                {{ st.PrettyName }}
                            </b-button>
                        </b-row>
                    </b-col>
                    <b-col v-if="currSeqType">
                        <b-card>
                            <b-card-header>
                                <h1>{{ currSeqType.PrettyName }}</h1>
                                <h4>{{ currSeqType.Description }}</h4>
                            </b-card-header>
                            <b-card-body>
                                <b-row>
                                    <b-col cols="1"><label>Aktiv serie:</label></b-col>
                                    <b-col><label>Startnr:</label></b-col>
                                    <b-col><label>Slutnr:</label></b-col>
                                    <b-col><label>Storlek:</label></b-col>
                                    <b-col><label>Aktivt nr:</label></b-col>
                                    <b-col><label>Kvar:</label></b-col>
                                    <!-- <b-col></b-col> -->
                                    <b-col><label>Ordning:</label></b-col>
                                    <b-col></b-col>
                                </b-row>
                                <b-row v-for="s in currSequences" :key="s.SequenceId">
                                    <b-col cols="1">
                                        <b-icon-check v-if="IsActive(s)"></b-icon-check>
                                    </b-col>
                                    <b-col>
                                        <b-form-input type="number" step="1" min="0" v-model="s.StartNo"
                                            :readonly="!IsEdit(s)">
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        <b-form-input type="number" v-model="s.EndNo" step="1" min="1"
                                            :readonly="!IsEdit(s)">
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        {{ s.EndNo - s.StartNo }}
                                    </b-col>
                                    <b-col>
                                        <b-form-input type="number" v-model="s.ActiveNo" step="1" min="0"
                                            :readonly="!IsEdit(s)">
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        {{ s.EndNo - s.ActiveNo }}
                                    
                                        <b-progress :value="100 - 100 * (s.EndNo - s.ActiveNo) / (s.EndNo - s.StartNo)"
                                            show-progress animated></b-progress>
                                    </b-col>
                                    <b-col>
                                        <b-form-input type="number" v-model="s.SortOrder" step="1" min="0"
                                            :readonly="!IsEdit(s)">
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        <b-button v-if="!IsActive(s) && !IsEdit(s)" @click="Reset(s)">Nollställ
                                        </b-button><br/>
                                        <b-button v-if="!IsActive(s) && !IsEdit(s)" @click="SetActive(s)">Gör aktiv
                                        </b-button><br/>
                                        <b-button v-if="!IsActive(s) && !IsEdit(s)" @click="Process(s)">Processa
                                        </b-button><br/>                                   
                                        <b-button v-if="!IsActive(s) && !editSequence && !IsEdit(s)"
                                            @click="editSequence = s">Redigera</b-button><br/>
                                        <b-button v-if="IsEdit(s)" @click="Save(s)">Spara</b-button>
                                        <b-button v-if="IsEdit(s)" @click="CancelEdit()">Avbryt</b-button>
                                        <b-button variant="danger" v-if="IsEdit(s)" @click="Remove(s)">Ta bort
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-card v-if="currProcessSequence">
                                        <b-card-body title="Processar">                                            
                                            <b-row>
                                                <b-col>
                                                    <b-progress :value="100 - 100 * (currProcessSequence.EndNo - currProcessNo) / (currProcessSequence.EndNo - currProcessSequence.StartNo)" show-progress animated></b-progress>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <b-button @click="StopProcess()">Avbryt processen</b-button>
                                                </b-col>
                                            </b-row>
                                        </b-card-body>
                                    </b-card>
                                </b-row>
                                <b-button v-if="!editSequence" @click="New()">+ Lägg till...</b-button>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
        <br />
        <br />
        <br />
    </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'sequence',
    components: {},
    data() {
        return {
            seqTypes: [],
            currSeqType: null,
            currSequences: [],
            editSequence: null,
            currProcessNo:null,
            currProcessSequence:null,
        }
    },
    created() {
        this.GetSequenceTypes();
    },
    methods: {
        GetSequenceTypes() {
            api.get('/api/booking/GetSequenceTypes').then(res => {
                this.seqTypes = res.data;
                if(this.currSeqType)
                    this.currSeqType = this.seqTypes.find(x => x.SequenceTypeId==this.currSeqType.SequenceTypeId);
            });
        },
        SelectSeqType(st) {
            this.currSeqType = st;
            this.currSequences = null;
            this.editSequence = null;
            api.get('/api/booking/GetSequences?sequenceTypeId=' + st.SequenceTypeId).then(res => {
                this.currSequences = res.data;
            });
        },
        IsActive(s) {
            return (this.currSeqType && s.SequenceId == this.currSeqType.CurrentSequenceId);
        },
        IsEdit(s) {
            return (this.editSequence && s == this.editSequence);
        },
        Reset(s) {
            if (confirm("Vill du nollställa serien?")) {
                s.ActiveNo = s.StartNo;
                this.Save(s);
            }
        },
        Save(s) {
            api.post('/api/booking/AddOrUpdateSequence', s).then(res => {
                if (res.data) {
                    alert('FEL:' + res.data);
                    return;
                }
                this.SelectSeqType(this.currSeqType);
            });
        },
        CancelEdit() {
            this.SelectSeqType(this.currSeqType);
        },
        New() {
            this.editSequence = { SequenceTypeId: this.currSeqType.SequenceTypeId, StartNo: 0, EndNo: 0, ActiveNo: 0 };
            this.currSequences.push(this.editSequence);
        },
        Remove(s) {
            if (confirm('Vill du ta bort serien?')) {
                api.delete('/api/booking/RemoveSequence?sequenceId=' + s.SequenceId).then(this.AlertOrReload);
            }
        },
        SetActive(s) {
            if (confirm("Vill du göra serien aktiv?")) {
                api.post('/api/booking/SetActiveSequence', s).then(this.AlertOrReload);
            }
        },
        AlertOrReload(res) {
            if (res.data) {
                alert(res.data);
                return;
            }
            this.GetSequenceTypes();
            this.SelectSeqType(this.currSeqType);
        },
        Process(s) {            
            if(confirm("Vill du processa serien, dvs kontrollera lediga nummer?")) {
                this.currProcessSequence = s;
                this.currProcessNo = s.StartNo;
                this.ProcessNext();
            }
        },
        StopProcess() {
            if(this.currProcessSequence)
                if(confirm("Vill du avsluta processen?")) {
                    this.currProcessSequence = null;
                    this.currProcessNo = null;
                }
        },
        ProcessNext() {
            if(this.currProcessSequence) {
                let minNo =  this.currProcessNo;
                let maxNo = minNo + 100; //Step size
                if(maxNo > this.currProcessSequence.EndNo)
                    maxNo = this.currProcessSequence.EndNo;
                api.post(`/api/Booking/RefreshSequenceInterval?minNo=${minNo}&maxNo=${maxNo}`).then(res => {
                    if(!this.currProcessSequence) {
                        alert('Processen avbruten.');
                        return; //Finished
                    }
                        
                    this.currProcessNo = maxNo;
                    if(maxNo >= this.currProcessSequence.EndNo) {
                        this.currProcessSequence = null;
                        alert('Processen klar!');
                        return;
                    }
                    this.$forceUpdate();
                    setTimeout(() => {
                        this.ProcessNext()
                    }, 100);
                });
            }
        }
    }
}
</script>